import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export class FacilitySlider {
  constructor() {
    const els = [...document.getElementsByClassName('js-facility_sub_slider')]
    els.map((elm) => {
      const progressBar = elm.nextElementSibling ? elm.nextElementSibling.querySelector('.c-slider_progress_bar') : null
      const slider = new KeenSlider(elm, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 2.5,
          // origin: 'center',
          spacing: 12,
        },
        slideChanged(s) {
          if (progressBar) {
            const current = s.track.details.rel
            const total = s.track.details.slides.length - 1
            const progressPercent = (current / total) * 100
            progressBar.style.width = `${progressPercent}%`
          }
        },
      })
    })
  }
}
